import React from 'react';
import { useTranslation } from 'react-i18next';
import { useItemValue } from '@/hooks/tab';
import { useItem } from '@/hooks/item';
import { Skeleton } from '@mui/material';
import { ServiceErrorView } from '@/components/atoms/Error';
import { Heading } from '@/components/atoms/Sidebar';
import Item from '@/components/molecules/sidebar/Item';
import styles from './Common.module.scss';

const View: React.FC = () => {
  const { t } = useTranslation();
  const [inputValue] = useItemValue();
  const data = useItem(Number(inputValue));

  return (
    <div
      className={styles.container}
      data-cy="SideBar-Item"
    >
      <Heading label={`${t('sidebar.result_for')} '${inputValue}'`} />
      {data.kind === 'Called' && (
        <Skeleton
          height={100}
          variant="rounded"
        />
      )}
      {data.kind === 'Error' && <ServiceErrorView error={data.error} />}
      {data.kind === 'Loaded' && (
        <Item
          withBorder={true}
          productId={data.data.productId}
          productName={data.data.productName}
          brandName={data.data.brandName}
          soldDate={data.data.soldDate}
          imageUrl={data.data.imageUrl}
        />
      )}
    </div>
  );
};

export default View;
